import { faTimes } from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';
import React, { Component, PropsWithChildren } from 'react';
import { Icon } from '../Icon';
import { withModalContext } from './ModalContext';
import { IModalHeaderProps } from './types';

import styled, { ThemeProvider } from 'styled-components';

const Title = styled.h4`
  flex-grow: 1;
`;

/**
 * Wrapper for the top part of a Modal to maintain appropriate Modal structure
 */
export class ModalHeader extends Component<PropsWithChildren<IModalHeaderProps>, {}> {
  public render() {
    const headerClassNames = classNames('modal-header', {
      'draggable-cursor': this.props.draggable === true,
    });
    return (
      <div className={headerClassNames}>
        {this.maybeRenderTitle()}
        {this.maybeRenderCloseButton()}
      </div>
    );
  }

  private maybeRenderCloseButton() {
    const preventDraggingClass = 'cancel-dragging';
    if (this.props.closeButton) {
      return (
        <ThemeProvider
          theme={{
            iconBackground: 'hsla(0, 0%, 50%, 0.5)',
            iconHoverColor: 'white',
          }}
        >
          <Icon
            icon={faTimes}
            title="close"
            onClick={this.props.handleClose}
            className={`close ${preventDraggingClass}`}
          />
        </ThemeProvider>
      );
    }

    return null;
  }

  private maybeRenderTitle() {
    if (this.props.title) {
      return <Title className={'modal-title'}>{this.props.title}</Title>;
    }

    return null;
  }
}

/**
 * We export ModalHeader as it is to support Styleguist's patterns.
 * And we export enhanced component as default for the actual usage
 * @see {@link https://react-styleguidist.js.org/docs/thirdparties.html}
 */
export default withModalContext(ModalHeader);
